export enum Logo {
    mba = "mba",
    default = "default"
}
